// libraries and utilities
import { put, call, takeEvery } from "redux-saga/effects";
import { ErrorResponse } from "../../interfaces/ErrorResponse";
import { apiGet, BASE_URL, retrieveToken } from "../../store/api";
import { StatusKerjasamaDetailResponse } from "./types";

import * as statusKerjasamaActions from "./statusKerjasama.actions";

export function* getStatusKerjasama(
  action: ReturnType<typeof statusKerjasamaActions.getDetailStatusKerjasamaAsync.request>
) {
  try {
    const token: string = yield retrieveToken();
    const url = BASE_URL + `status-kerjasama/${action.payload.id}`;
    const result: Response = yield call(apiGet, url, token);

    if (result.status === 200) {
      const parsed: StatusKerjasamaDetailResponse = yield call(result.json.bind(result));
      yield put(statusKerjasamaActions.getDetailStatusKerjasamaAsync.success(parsed));
      return; 
    } else {
      const parsed: ErrorResponse = yield call(result.json.bind(result));
      yield put(statusKerjasamaActions.getDetailStatusKerjasamaAsync.failure(parsed));
      return;
    }
  } catch (err) {
    const parsed: ErrorResponse = {
      name: 'Internal server error',
      message: 'Internal server error',
      code: 500,
      status: 500
    }
    yield put(statusKerjasamaActions.getDetailStatusKerjasamaAsync.failure(parsed));
  }
}

export default function* statusKerjasamaSagaGetDetailStatusKerjasama() {
  yield takeEvery(statusKerjasamaActions.getDetailStatusKerjasamaAsync.request, getStatusKerjasama);
}
